import { FC, ReactNode } from 'react';

type EventGuardProps = {
  eventType: string;
  condition?: boolean;
  children: ReactNode;
};

export const PhysicalEvent: FC<EventGuardProps> = ({
  eventType,
  condition = true,
  children,
}) => (['ev_classroom', 'classroom'].includes(eventType) && condition ? children : null);

export const VirtualEvent: FC<EventGuardProps> = ({
  eventType,
  condition = true,
  children,
}) => (['ev_virtual', 'virtual'].includes(eventType) && condition ? children : null);

export const TeleconferenceEvent: FC<EventGuardProps> = ({
  eventType,
  condition = true,
  children,
}) => (['ev_call', 'call'].includes(eventType) && condition ? children : null);
